import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid, parseOptions} from '../question-helper';
import {QuestionType} from '../../constants';
import {Profession} from '../../models/Profession';
import {Industry} from '../../models/Industry';

declare const $: any;
declare const easyAutocomplete: any;

@Component({
    selector: 'app-question-autocomplete-generic',
    templateUrl: './question-autocomplete-generic.component.html',
    styleUrls: ['./question-autocomplete-generic.component.scss'],
    standalone: false
})
export class QuestionAutocompleteGenericComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() items: any[];
  @Input() placeHolder = 'Profession';
  @Input() inputType = 'text';
  @Input() value: any;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlId = `textbox-autocomplete-${newGuid()}`;
  uniqueControlName = `textbox-autocomplete-${newGuid()}`;

  QuestionTypes = QuestionType;
  professions: Profession[] = [];
  industries: Industry[] = [];

  constructor(private globalQuestionService: GlobalQuestionService) {
  }
  

  ngOnInit(): void {
    this.globalQuestionService.spinner(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.question?.question_prompt) {
          this.placeHolder = this.question?.question_prompt;
        }
        this.value = this.question?.answer;
        this.globalQuestionService.spinner(true);
        this.getData();
      }
    }
  }

  getData(): void {
    this.items = [];
      if (this.question?.options) {
        this.items = parseOptions(this.question?.options);
      }
    this.initAutoComplete(this.items);
    this.globalQuestionService.spinner(false);
  }

  onChange(type: QuestionType): void {
    if (this.question) {
      if (this.value) {
        this.question.answer = this.value;
        this.questionAnswer.emit(this.question);
      } else {
        this.question.answer = '';
        this.questionAnswer.emit(this.question);
      }
    }
  }

 
  initAutoComplete(items: any[]): void {
    setTimeout(() => {
      $(`#${this.uniqueControlId}`).easyAutocomplete({
        data: items,
        getValue: x => {
         return x.answer;
        },
        list: {
          match: {
            enabled: true
          },
          sort: {
            enabled: true // alphabetical order
          },
          onChooseEvent: () => {
            const selected = $(`#${this.uniqueControlId}`).getSelectedItemData();
            this.value = selected.answer;
            this.question.answer = this.value;
            this.question.answer_id = selected.cent_aq_answer_id;
            this.questionAnswer.emit(this.question);
          },
        },
       
      });
      $(`#${this.uniqueControlId}`).focus();
    }, 2000);
  }
}
